import { render, staticRenderFns } from "./SearchProduct.vue?vue&type=template&id=62346d51&scoped=true"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"
import style0 from "./SearchProduct.vue?vue&type=style&index=0&id=62346d51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62346d51",
  null
  
)

export default component.exports